(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["eko-review-stars"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eko-review-stars')) {
    customElements.define(
      'eko-review-stars',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.dataset.label) return;
          this.apply();
          this.observer = this.observer || new MutationObserver(() => this.apply());
          this.observer.observe(this, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['aria-label', 'role', 'aria-hidden'],
          });
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        apply() {
          const stars = this.querySelector('.jdgm-prev-badge__stars');
          if (!stars) return;
          const isButton = stars.getAttribute('role') === 'button';
          const label = isButton ? `${this.dataset.label}. ${this.dataset.action}` : this.dataset.label;
          if (stars.getAttribute('aria-label') !== label) stars.setAttribute('aria-label', label);
          const text = this.querySelector('.jdgm-prev-badge__text');
          if (text && text.getAttribute('aria-hidden') !== 'true') text.setAttribute('aria-hidden', 'true');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
